<template>
	<div v-loading="loading" class="device-list">
		<el-scrollbar ref="out" v-if="showScroll">
			<div v-bind:style="{ width: jt_list.length * 120 + 'px', height: '140px' }">
				<div :class="getJT_Class(item)" v-for="(item, index) in jt_list" :key="index" @click="showJTInfo(item)">
					<el-tooltip class="item" effect="dark" :content="item.name" placement="top">
						<div>
							<div class="device-name">
								<label v-text="item.name">11111</label>
							</div>
							<div class="device-info">
								<span v-text="getJT_StatusStr(item.statusInfo.status_icw)"></span>
							</div>
						</div>
					</el-tooltip>
				</div>
			</div>
		</el-scrollbar>
	</div>
</template>

<script>
	import Vue from 'vue'
	import { jtInfoRequest } from '@/network/requests/jtInfo'
	import { jtStatusRequest, jtStatusEnum, jtStatusICWEnum } from '@/network/requests/jtStatus'
	import jtService from '@/service/jtService'
	import { QUALITY_MONITOR_MACHINE } from '@/store/mutation-types'
	export default {
		data() {
			return {
				/**
				 * 机台集合。
				 */
				jt_list: [],
				loading: false,
				showScroll: true,
				selected: '',
			}
		},
		props: {
			/**
			 * 车间ID。
			 */
			workshopId: {
				type: String,
			},
		},
		watch: {
			workshopId(val) {
				this.query()
			},
			jt_list(val) {
				this.showScroll = false
				this.$nextTick(() => {
					this.showScroll = true
				})
			},
		},
		methods: {
			/**
			 * 查询设备。
			 */
			async query() {
				this.loading = true
				var jt_filter = undefined
				if (this.workshopId) {
					jt_filter = {}
					jt_filter.workshop_id = this.workshopId
				}

				//查询所有机台。
				var jtList = await jtInfoRequest.queryAll(jt_filter)
				//获取机台状态集合。
				var jt_status = await jtStatusRequest.queryAll({ jt_id: { $in: jtList.map(t => t._id.$oid) } })

				var array = []
				jtList.forEach((v, i) => {
					//获取当前机台的状态信息。
					var js = jt_status.find(t => t.jt_id == v._id.$oid) ?? {}
					var js2 = jtService.getDeviceStatusFromCache(js)

					//加入机台状态。
					array.push({
						...v,
						statusInfo: js2,
					})
				})

				this.loading = false
				this.jt_list = array

				var selected_jt = null
				//如果第一次没有选中的机台，这里默认选择第一个机台。
				if (!this.selected) {
					if (this.jt_list) selected_jt = this.jt_list[0]
				} else {
					selected_jt = this.jt_list.find(t => t._id.$oid == this.selected)
				}
				//选择默认机台。
				if (selected_jt) {
					this.showJTInfo(selected_jt)
				}
			},
			/**
			 * 获取机台状态字符串。
			 */
			getJT_StatusStr(val) {
				if (jtStatusICWEnum[val]) {
					return jtStatusICWEnum[val].text
				}
				return '--'
			},
			/**
			 * 根据机台状态显示不同颜色。
			 */
			getJT_Class(item) {
				var classObj = {
					'device-item': true,
					selected: this.selected == item._id.$oid,
				}

				classObj['bg_color_' + item.statusInfo.status_icw] = true

				return classObj
			},
			/**
			 * 显示机台状态。
			 */
			showJTInfo(item) {
				Vue.ls.set(QUALITY_MONITOR_MACHINE, item._id.$oid, 7 * 24 * 60 * 60 * 1000)
				this.$emit('select', item)
				this.selected = item._id.$oid
			},
		},
		mounted() {},
		created() {
			//从本地缓存读取最后选中的机台。
			this.selected = Vue.ls.get(QUALITY_MONITOR_MACHINE)
			this.query()
		},
	}
</script>

<style scoped>
	.device-list {
		margin-bottom: 30px;
		background-color: #f5f5f5;
		margin-left: -19px;
		margin-right: -20px;
		border-left: none;
		border-right: none;
		height: 140px;
	}

	.device-item:first-child {
		margin-left: 10px;
	}
	.device-item {
		display: block;
		float: left;
		width: 100px;
		height: 100px;
		border: 1px #c7c7c7 solid;
		background-color: #fafafa;
		position: relative;
		margin-right: 10px;
		margin-bottom: 20px;
		margin-top: 20px;
	}

	.device-item:hover {
		cursor: pointer;
		background-color: #333;
	}
	.device-info {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		text-align: center;
		padding: 8px 0;
		font-size: 12px;
		background-color: #ffffff6e;
	}

	.device-info span {
		color: #000;
	}

	.device-name {
		text-align: center;
		line-height: 68px;
		background-color: #dcdcdc;
		font-size: 14px;
		overflow: hidden;
		color: #777;
	}

	.device-item.selected {
		border: 1px #333 solid;
	}

	.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
		white-space: nowrap;
	}

	.bg_color_0 {
		background-color: rgb(141, 141, 141);
	}

	.bg_color_1 {
		background-color: rgb(203, 49, 152);
	}

	.bg_color_2 {
		background-color: rgb(255, 196, 0);
	}

	.bg_color_3 {
		background-color: rgb(236, 0, 0);
	}

	.device-status {
		border-radius: 4px;
	}
</style>
